"use strict";
/*
 * Created on 11 10 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Aggregated data representing a product offered by a concrete supplier.
 *
 * @author Radek Beran
 */


var SuppliedProduct =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SuppliedProduct, _DomainObject_1$Domai);

  /**
   * @param id id unique id of this entity
   * @param productId id of product
   * @param productName name of product
   * @param productExternalId external id of internal product
   * @param supplierId id of supplier or null if this product has no supplier
   * @param supplierName name of supplier or null if this product has no supplier
   * @param cmCategoryId id of category-manager-level category
   * @param categoryPlanId id of category-plan-level category
   * @param categoryPlanName name of category-plan-level category
   * @param category4BOXName name of 4BOX-level category FIXME 4BOX is client specific
   */
  function SuppliedProduct(id, productId, productName, productExternalId, supplierId, supplierName, cmCategoryId, categoryPlanId, categoryPlanName, category4BOXName) {
    var _this;

    _classCallCheck(this, SuppliedProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProduct).call(this));
    _this.id = id;
    _this.productId = productId;
    _this.productName = productName;
    _this.productExternalId = productExternalId;
    _this.supplierId = supplierId;
    _this.supplierName = supplierName;
    _this.cmCategoryId = cmCategoryId;
    _this.categoryPlanId = categoryPlanId;
    _this.categoryPlanName = categoryPlanName;
    _this.category4BOXName = category4BOXName;
    return _this;
  }

  return SuppliedProduct;
}(DomainObject_1.DomainObject);

exports.SuppliedProduct = SuppliedProduct;

SuppliedProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SuppliedProduct.name);
  return {
    id: builder.id('id'),
    productId: builder.id('productId'),
    productName: builder.str('productName'),
    productExternalId: builder.str('productExternalId'),
    supplierId: builder.opt(builder.id('supplierId')),
    supplierName: builder.opt(builder.str('supplierName')),
    cmCategoryId: builder.id('cmCategoryId'),
    categoryPlanId: builder.id('categoryPlanId'),
    categoryPlanName: builder.str('categoryPlanName'),
    category4BOXName: builder.str('category4BOXName')
  };
}();